import React from 'react';
import i18next from "i18next";

import { Message } from "../Message";
import { PageTitle } from "../PageTitle";
import { DevicesRegistrationService } from "../../services";
import DeviceRegistrationList from "./registration_list";

class DeviceRegistrations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            localErrorMessage: null,
            localSuccessMessage: null,
            deviceRegistrations: null,
            loading: false
        }
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        DevicesRegistrationService.getRegistrations().then(response => {
            this.setState({
                deviceRegistrations: response.response.registrations,
                loading: false
            });
        }).catch((err) => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleLocalError(localErrorMessage) {
        this.setState({ localErrorMessage: localErrorMessage });
    }    

    handleLocalSuccess(localSuccessMessage) {
        this.setState({ localSuccessMessage: localSuccessMessage });
    }    

    messageDismissCallback() {
        this.setState({ localErrorMessage: null, localSuccessMessage: null });
    }

    renderMessages() {
        if (this.state.localErrorMessage) {
            return (
                <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
            );
        }

        if (this.props.location.state) {
            return (
                <Message messages={this.props.location} />
            );
        }

        if (this.state.localSuccessMessage) {
            return (
                <Message messages={{ state: { successMessage: this.state.localSuccessMessage } }} messageDismissCallback={ this.messageDismissCallback.bind(this) } />
            );
        }

        return null;
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <PageTitle title={ i18next.t('pages.device-registrations.header') }
                            refreshFunction={this.refresh.bind(this)}
                            customButton={{
                                link: {pathname: '/config/registrations/add'},
                                title: i18next.t('pages.device-registrations.add')
                            }} />
                </div>
                { this.renderMessages() }
                <div className="op-content-box">
                    <div className="row">
                        <div className="col-sm-12">
                            <div>
                                <div className="card-block">

                                    {
                                        this.state.deviceRegistrations ? 
                                        <DeviceRegistrationList
                                            refreshFunction={this.refresh.bind(this)}
                                            registrations={this.state.deviceRegistrations}
                                            localErrorHandler={this.handleLocalError.bind(this)}
                                            handleLocalSuccess={this.handleLocalSuccess.bind(this)}
                                            loading={this.state.loading}
                                        /> : <div className="loader">Loading...</div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );        
    }
}

export default DeviceRegistrations;